import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _23a4147b = () => interopDefault(import('../pages/500.vue' /* webpackChunkName: "pages/500" */))
const _1c4468ea = () => interopDefault(import('../pages/articles/index.vue' /* webpackChunkName: "pages/articles/index" */))
const _07b969e6 = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _2b2fe1e2 = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _168b6cb3 = () => interopDefault(import('../pages/checkout/index.vue' /* webpackChunkName: "pages/checkout/index" */))
const _4e64555e = () => interopDefault(import('../pages/collections/index.vue' /* webpackChunkName: "pages/collections/index" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _dec39a74 = () => interopDefault(import('../pages/journey.vue' /* webpackChunkName: "pages/journey" */))
const _4bb7511c = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _e5ecd1a8 = () => interopDefault(import('../pages/quick-buy.vue' /* webpackChunkName: "pages/quick-buy" */))
const _211f388a = () => interopDefault(import('../pages/sign-in.vue' /* webpackChunkName: "pages/sign-in" */))
const _0406ba31 = () => interopDefault(import('../pages/sign-up.vue' /* webpackChunkName: "pages/sign-up" */))
const _767ccc15 = () => interopDefault(import('../pages/checkout/payout.vue' /* webpackChunkName: "pages/checkout/payout" */))
const _64d4002e = () => interopDefault(import('../pages/profile/order-tracking/index.vue' /* webpackChunkName: "pages/profile/order-tracking/index" */))
const _6e9f86f5 = () => interopDefault(import('../pages/profile/orders.vue' /* webpackChunkName: "pages/profile/orders" */))
const _0cb48b53 = () => interopDefault(import('../pages/profile/shipping-addresses.vue' /* webpackChunkName: "pages/profile/shipping-addresses" */))
const _98579e62 = () => interopDefault(import('../pages/checkout/success/_id.vue' /* webpackChunkName: "pages/checkout/success/_id" */))
const _efaa0358 = () => interopDefault(import('../pages/profile/order-tracking/_id/index.vue' /* webpackChunkName: "pages/profile/order-tracking/_id/index" */))
const _15b9bec1 = () => interopDefault(import('../pages/articles/_section/index.vue' /* webpackChunkName: "pages/articles/_section/index" */))
const _e39aa696 = () => interopDefault(import('../pages/cart/_id.vue' /* webpackChunkName: "pages/cart/_id" */))
const _2979409a = () => interopDefault(import('../pages/catalog/_slug.vue' /* webpackChunkName: "pages/catalog/_slug" */))
const _3362ffdb = () => interopDefault(import('../pages/checkout/_id.vue' /* webpackChunkName: "pages/checkout/_id" */))
const _14413a86 = () => interopDefault(import('../pages/collection/_slug/index.vue' /* webpackChunkName: "pages/collection/_slug/index" */))
const _27eb6c73 = () => interopDefault(import('../pages/product/_slug/index.vue' /* webpackChunkName: "pages/product/_slug/index" */))
const _116f3964 = () => interopDefault(import('../pages/recover-password/_token/index.vue' /* webpackChunkName: "pages/recover-password/_token/index" */))
const _0e2b5df0 = () => interopDefault(import('../pages/return/_id/index.vue' /* webpackChunkName: "pages/return/_id/index" */))
const _bcedac4e = () => interopDefault(import('../pages/verify/_token/index.vue' /* webpackChunkName: "pages/verify/_token/index" */))
const _14031d79 = () => interopDefault(import('../pages/articles/_section/_slug.vue' /* webpackChunkName: "pages/articles/_section/_slug" */))
const _2efaf336 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/500",
    component: _23a4147b,
    name: "500___de"
  }, {
    path: "/articles",
    component: _1c4468ea,
    name: "articles___de"
  }, {
    path: "/cart",
    component: _07b969e6,
    name: "cart___de"
  }, {
    path: "/catalog",
    component: _2b2fe1e2,
    name: "catalog___de"
  }, {
    path: "/checkout",
    component: _168b6cb3,
    name: "checkout___de"
  }, {
    path: "/collections",
    component: _4e64555e,
    name: "collections___de"
  }, {
    path: "/en",
    component: _2dfb1658,
    name: "index___en"
  }, {
    path: "/journey",
    component: _dec39a74,
    name: "journey___de"
  }, {
    path: "/profile",
    component: _4bb7511c,
    name: "profile___de"
  }, {
    path: "/quick-buy",
    component: _e5ecd1a8,
    name: "quick-buy___de"
  }, {
    path: "/sign-in",
    component: _211f388a,
    name: "sign-in___de"
  }, {
    path: "/sign-up",
    component: _0406ba31,
    name: "sign-up___de"
  }, {
    path: "/checkout/payout",
    component: _767ccc15,
    name: "checkout-payout___de"
  }, {
    path: "/en/500",
    component: _23a4147b,
    name: "500___en"
  }, {
    path: "/en/articles",
    component: _1c4468ea,
    name: "articles___en"
  }, {
    path: "/en/cart",
    component: _07b969e6,
    name: "cart___en"
  }, {
    path: "/en/catalog",
    component: _2b2fe1e2,
    name: "catalog___en"
  }, {
    path: "/en/checkout",
    component: _168b6cb3,
    name: "checkout___en"
  }, {
    path: "/en/collections",
    component: _4e64555e,
    name: "collections___en"
  }, {
    path: "/en/journey",
    component: _dec39a74,
    name: "journey___en"
  }, {
    path: "/en/profile",
    component: _4bb7511c,
    name: "profile___en"
  }, {
    path: "/en/quick-buy",
    component: _e5ecd1a8,
    name: "quick-buy___en"
  }, {
    path: "/en/sign-in",
    component: _211f388a,
    name: "sign-in___en"
  }, {
    path: "/en/sign-up",
    component: _0406ba31,
    name: "sign-up___en"
  }, {
    path: "/profile/order-tracking",
    component: _64d4002e,
    name: "profile-order-tracking___de"
  }, {
    path: "/profile/orders",
    component: _6e9f86f5,
    name: "profile-orders___de"
  }, {
    path: "/profile/shipping-addresses",
    component: _0cb48b53,
    name: "profile-shipping-addresses___de"
  }, {
    path: "/en/checkout/payout",
    component: _767ccc15,
    name: "checkout-payout___en"
  }, {
    path: "/en/profile/order-tracking",
    component: _64d4002e,
    name: "profile-order-tracking___en"
  }, {
    path: "/en/profile/orders",
    component: _6e9f86f5,
    name: "profile-orders___en"
  }, {
    path: "/en/profile/shipping-addresses",
    component: _0cb48b53,
    name: "profile-shipping-addresses___en"
  }, {
    path: "/en/checkout/success/:id?",
    component: _98579e62,
    name: "checkout-success-id___en"
  }, {
    path: "/en/profile/order-tracking/:id",
    component: _efaa0358,
    name: "profile-order-tracking-id___en"
  }, {
    path: "/checkout/success/:id?",
    component: _98579e62,
    name: "checkout-success-id___de"
  }, {
    path: "/en/articles/:section",
    component: _15b9bec1,
    name: "articles-section___en"
  }, {
    path: "/en/cart/:id",
    component: _e39aa696,
    name: "cart-id___en"
  }, {
    path: "/en/catalog/:slug",
    component: _2979409a,
    name: "catalog-slug___en"
  }, {
    path: "/en/checkout/:id",
    component: _3362ffdb,
    name: "checkout-id___en"
  }, {
    path: "/en/collection/:slug",
    component: _14413a86,
    name: "collection-slug___en"
  }, {
    path: "/en/product/:slug",
    component: _27eb6c73,
    name: "product-slug___en"
  }, {
    path: "/en/recover-password/:token",
    component: _116f3964,
    name: "recover-password-token___en"
  }, {
    path: "/en/return/:id",
    component: _0e2b5df0,
    name: "return-id___en"
  }, {
    path: "/en/verify/:token",
    component: _bcedac4e,
    name: "verify-token___en"
  }, {
    path: "/profile/order-tracking/:id",
    component: _efaa0358,
    name: "profile-order-tracking-id___de"
  }, {
    path: "/en/articles/:section/:slug",
    component: _14031d79,
    name: "articles-section-slug___en"
  }, {
    path: "/articles/:section",
    component: _15b9bec1,
    name: "articles-section___de"
  }, {
    path: "/cart/:id",
    component: _e39aa696,
    name: "cart-id___de"
  }, {
    path: "/catalog/:slug",
    component: _2979409a,
    name: "catalog-slug___de"
  }, {
    path: "/checkout/:id",
    component: _3362ffdb,
    name: "checkout-id___de"
  }, {
    path: "/collection/:slug",
    component: _14413a86,
    name: "collection-slug___de"
  }, {
    path: "/product/:slug",
    component: _27eb6c73,
    name: "product-slug___de"
  }, {
    path: "/recover-password/:token",
    component: _116f3964,
    name: "recover-password-token___de"
  }, {
    path: "/return/:id",
    component: _0e2b5df0,
    name: "return-id___de"
  }, {
    path: "/verify/:token",
    component: _bcedac4e,
    name: "verify-token___de"
  }, {
    path: "/articles/:section/:slug",
    component: _14031d79,
    name: "articles-section-slug___de"
  }, {
    path: "/en/*",
    component: _2efaf336,
    name: "all___en"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index___de"
  }, {
    path: "/*",
    component: _2efaf336,
    name: "all___de"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
